import { render, staticRenderFns } from "./SimpleCurrencyInputV2.vue?vue&type=template&id=68f8f50f&"
import script from "./SimpleCurrencyInputV2.vue?vue&type=script&lang=js&"
export * from "./SimpleCurrencyInputV2.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCurrencyInputV2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports